import { Scrollbars } from '@meitu/saas-ui';
import { BackTitle, SimpleTitle } from '@meitu/saas-ui/es/title';
import { events } from '@/events-bus';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { useStoreState } from '@/store';
import { PLUGIN_CLOSE_EVENT } from '../../constants';
import ImportExcel from './import-excel';
import TablePresetList from './table-preset-list';
import './table-player.less';

const TablePlayer: React.FC = () => {
    const { $t } = useLocaleStore();
    const currentRecordId = useStoreState((state) => state.recordModel.recordInfo.id);

    return (
        <Scrollbars autoHide>
            <div className="plugin-table">
                <BackTitle
                    text={$t((v) => v.collapse.moreCollapse.componentTool.table.title)}
                    handleBackClick={() => {
                        events.emit(PLUGIN_CLOSE_EVENT);
                    }}
                />
                <div style={{ height: 16 }}></div>
                <ImportExcel editor={editor} />
                <div style={{ height: 28 }}></div>
                <SimpleTitle text={$t((v) => v.collapse.moreCollapse.componentTool.table.needSelected)} fontSize={14} />
                <div style={{ height: 12 }}></div>
                <TablePresetList editor={editor} currentRecordId={currentRecordId} />
                <div style={{ height: 12 }}></div>
            </div>
        </Scrollbars>
    );
};

TablePlayer.displayName = 'TablePlayer';

export const TABLE_PLAYER = 'table_player';

export default TablePlayer;
